// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"f726b172","787":"ace86681","850":"a8a2651e"}[chunkId] + ".chunk.js";
};